<template>
    <div class="productInfoBanner">
        <div class="btnLeft"  @click="add()">
            <img src="../../public/img/productItem/itemInfo/left.png" alt="" srcset="">
        </div>
        <div class="bannerView" ref="bannerView">
            <div class="showViewList" :style="`width:${bannerList.length*10}vw;left:${-index*8.5}vw;`">
                <div class="item" v-for="(item, index) in bannerList" :key="index" @click="changeMainImg(item)">
                    <div class="itemImg" :style="`background-image:url('${baseUrl+'img/productItem/itemInfo/'+imgUrl+'/'+item}')`">
                        <div class="itemText">{{item.text}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="btnLeft" @click="cut()">
            <img src="../../public/img/productItem/itemInfo/right.png" alt="" srcset="">
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            index:0,
            baseUrl:process.env.BASE_URL, 
        }
    },
    props:['imgList','imgUrl'],
    computed:{
        bannerList(){
            return this.imgList
        }
    },
    mounted(){
        this.$nextTick(() => {
            console.log(this.$refs.bannerView.offsetWidth)
        }) 
    },
    methods:{
        cut(){
            if(this.index<this.bannerList.length-6){
                this.index+=3
            }
        },
        add(){
            if(this.index>0){
                this.index-=3
            }
        },
        changeMainImg(url){
            this.$emit("changeimg", this.imgUrl+'/'+ url);
        }
    }
}
</script>
<style lang="less">
.productInfoBanner{
    margin-bottom: 5rem;
    width: 100%;
    height: 100px;
    margin-top: 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .bannerView{
        height: 100%;
        width: 90%;
        position: relative;
        overflow: hidden;
        .showViewList{
            position: absolute;
            left: 0;
            top: 0;
            transition: 0.5s ease-in-out all;
            .item{
                cursor: pointer;
                width: 8.5vw;
                // width: 20%;
                float: left;
                height: 100px;
                display: flex;
                align-items: center;
                justify-content: center;
                .itemImg{
                    width: 90%;
                    height: 100%;
                    background-repeat: no-repeat;
                    background-size: cover;
                    background-position: center;
                    position: relative;
                }
            }
        }
    }
    .btnLeft{
        height: 80%;
        width: 1rem;
        background-color: rgba(1, 124, 168, 0.31);
        border-radius: 3px;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 2px 2px rgba(0, 0, 0, 0.2);
        img{
            width: 60%;
        }
    }
}
</style>

